import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { api, formatApiErrorDetail } from "@/lib/api";

const EMPTY = { name: "", email: "", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [accepted, setAccepted] = useState(false);
  const [sending, setSending] = useState(false);
  const field = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!accepted) {
      toast.error("Debes aceptar la Política de privacidad para enviar el mensaje");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("¡Mensaje enviado! Te responderemos muy pronto.");
      setForm(EMPTY);
      setAccepted(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="md:col-span-7 space-y-5" data-testid="contact-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div className="space-y-2">
          <Label htmlFor="contact-name">Nombre</Label>
          <Input id="contact-name" data-testid="contact-name-input" required minLength={2}
            value={form.name} onChange={field("name")} placeholder="Tu nombre" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="contact-email">Correo electrónico</Label>
          <Input id="contact-email" data-testid="contact-email-input" type="email" required
            value={form.email} onChange={field("email")} placeholder="tu@correo.com" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="contact-message">Mensaje</Label>
        <Textarea id="contact-message" data-testid="contact-message-input" required minLength={5} rows={5}
          value={form.message} onChange={field("message")} placeholder="Cuéntanos qué necesitas..." />
      </div>
      <label className="flex items-start gap-3 text-sm text-slate-600 cursor-pointer" htmlFor="contact-privacy">
        <Checkbox id="contact-privacy" data-testid="contact-privacy-checkbox" checked={accepted}
          onCheckedChange={(v) => setAccepted(v === true)} className="mt-0.5" />
        <span>
          He leído y acepto la{" "}
          <Link to="/privacidad" className="text-cyan-700 underline underline-offset-2">Política de privacidad</Link>.
          Tus datos solo se usarán para responder a tu consulta.
        </span>
      </label>
      <Button type="submit" disabled={sending} data-testid="contact-submit-btn"
        className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-8 h-11 w-full sm:w-auto">
        <Send className="h-4 w-4 mr-2" /> {sending ? "Enviando..." : "Enviar Mensaje"}
      </Button>
    </form>
  );
};
